import React from 'react';
import { NavLink } from 'react-router-dom';
import { navigationConfig } from '../../config/navigation';
import SafeIcon from '../../common/SafeIcon';
import { FiX, FiHelpCircle } from 'react-icons/fi';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-slate-900/50 z-20 md:hidden"
          onClick={toggleSidebar}
        />
      )}

      <aside className={`
        fixed md:static inset-y-0 left-0 z-30
        w-64 bg-slate-900 text-slate-300 flex flex-col
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
      `}>
        <div className="h-16 flex items-center justify-between px-4 border-b border-slate-800">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-lg shadow-blue-950/30">
              B
            </div>
            <div>
              <span className="font-semibold text-white tracking-wide block leading-tight">BPA Gateway</span>
              <span className="text-[9px] uppercase tracking-[0.18em] text-slate-500">Secure Console</span>
            </div>
          </div>
          <button onClick={toggleSidebar} className="md:hidden p-1 hover:bg-slate-800 rounded">
            <SafeIcon icon={FiX} className="text-xl" />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto py-4 custom-scrollbar">
          <ul className="space-y-1 px-2">
            {navigationConfig.filter(item => item.path !== '/help').map((item) => (
              <li key={item.name}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => `
                    flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors
                    ${isActive
                      ? 'bg-blue-500/10 text-blue-400'
                      : 'hover:bg-slate-800 hover:text-white'}
                  `}
                  onClick={() => window.innerWidth < 768 && toggleSidebar()}
                >
                  <SafeIcon icon={item.icon} className="text-lg opacity-80" />
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="border-t border-slate-800 px-3 pt-3">
          <NavLink to="/help" onClick={() => window.innerWidth < 768 && toggleSidebar()} className={({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-semibold transition-colors ${isActive ? "bg-blue-600 text-white" : "bg-slate-800 text-slate-100 hover:bg-slate-700"}`}>
            <SafeIcon icon={FiHelpCircle} className="text-lg" /> Help & FAQ
          </NavLink>
        </div>
        <div className="p-4 border-t border-slate-800/50 mt-3">
          <p className="text-[10px] font-bold uppercase tracking-widest text-emerald-400">Production Foundation</p>
          <p className="text-[10px] text-slate-500 mt-1">Phase 1</p>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;